import { config } from '@rematter/config';
import { maybe } from '@rematter/ui-web';

import { purchaseOrderListQueryAtom } from '../_graphql/queryPurchaseOrderList';

import { atomFromQueryString } from '~/shared/state';

// 🟣🟣🟣 PARAMS
export const $searchParam = atomFromQueryString.string('q');
export const $limit = atomFromQueryString.number('limit', config.pageSize);
export const $offset = atomFromQueryString.number('offset', 0);

// 🟢🟢🟢 REMOTE DATA
export const $purchaseOrders = purchaseOrderListQueryAtom((get) => ({
  variables: {
    searchTerm: get($searchParam),
    pagination: maybe(get($limit), (limit) => ({
      limit,
      offset: get($offset) ?? 0,
    })),
  },
}));
